import type {
    MutableWorkflowState,
} from '@toolproof-core/lib/_contract/workflow-overlay';

import {
    resolveWorkflowStateEntryResolution,
    type WorkflowStateEntryResolutionResult,
} from '@/workflow/_pure/derivation/workflowStateEntryResolution';

export type { WorkflowStateEntryResolutionResult };

export function resolveWorkflowStateEntryMaterializedEntry(args: {
    direction: 'input' | 'output';
    stepKey: string;
    roleName: string;
    workflowState: MutableWorkflowState;
}): WorkflowStateEntryResolutionResult {
    return resolveWorkflowStateEntryResolution(args);
}
